import React, { useCallback }      from 'react';
import { useHistory }              from 'react-router-dom';
import styled                      from 'styled-components';
import { Table, CircularProgress } from '@material-ui/core';
import { IDataTableProps }         from '@typings/components';
import { DataTableHead }           from './DataTableHead';
import { DataTableBody }           from './DataTableBody';

const Wrapper = styled.div`
  ${({ minwidth }: any): string => minwidth && `min-width: ${minwidth}`};
  max-width : ${({ maxwidth }: any): string => maxwidth || '1680px'};
  margin    : ${({ margin }: any): string => margin || '20px 0'};
` as any;

const StyledTable = styled(Table)`
  tbody:before {
    content     : "@";
    display     : block;
    line-height : 15px;
    text-indent : -99999px;
  }

  thead th {
    border-bottom  : 1px solid #707070;
    padding-bottom : 8px;
    font-size      : 16px;
  }
`;

const LoadingWrapper = styled.div`
  display         : flex;
  justify-content : center;
  align-items     : center;
  padding         : 48px 0;
  color           : #AFAFAF;
`;

const NoResultWrapper = styled.div`
  display         : flex;
  justify-content : center;
  align-items     : center;
  padding         : 48px 0;
  font-size       : 18px;
  color           : ${({ theme: { textColor } }): string => textColor.gray};
`;

export const DataTable = ({
  rows,
  title,
  margin,
  headers,
  loading,
  minwidth,
  maxwidth,
  aligntop,
  rowheight,
  collapsed,
  collapsable,
  placeholder,
}: IDataTableProps): JSX.Element => {
  const history = useHistory();

  const handlePush = useCallback(
    (link: string): void => {
      history.push(link);
    }, [history],
  );

  return (
    <Wrapper
      margin   = {margin}
      minwidth = {minwidth}
      maxwidth = {maxwidth}
    >
      <StyledTable>
        {(title || headers) && (
          <DataTableHead
            title   = {title}
            headers = {headers}
          />
        )}

        {!loading && !!rows.length && (
          <DataTableBody
            rows        = {rows}
            aligntop    = {aligntop}
            rowheight   = {rowheight}
            collapsed   = {collapsed}
            collapsable = {collapsable}
            handlePush  = {handlePush}
          />
        )}
      </StyledTable>

      {loading ? (
        <LoadingWrapper>
          <CircularProgress />
        </LoadingWrapper>
      ) : (
        <>
          {!rows.length && placeholder && (
            <NoResultWrapper>
              {placeholder}
            </NoResultWrapper>
          )}
        </>
      )}
    </Wrapper>
  );
};

DataTable.defaultProps = {
  placeholder: '- No Results Found -',
};
